module.exports = __webpack_public_path__ + "static/assets/b26220acbc02c8b75ae2640fcdf15a04.svg";